import { render } from "./Tes.vue?vue&type=template&id=25118f4a&scoped=true&ts=true"
import script from "./Tes.vue?vue&type=script&lang=ts"
export * from "./Tes.vue?vue&type=script&lang=ts"

import "./Tes.vue?vue&type=style&index=0&id=25118f4a&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25118f4a"]])

export default __exports__